<template>

    <button class="app-button app-btn round button-primary"
            :disabled="disabled"
            :class="{'is-loading': loading, 'is-disabled': disabled}"
            :type="type"
            :style="style"
            @click="onClick">
        <span class="inner">
            <span class="icon" v-if="icon" v-html="$icon(icon)"></span>
            <span class="text"><slot></slot></span>
        </span>

        <span class="loader" v-if="loading" v-html="$icon('loader')"></span>

    </button>

</template>

<script>

    export default {
        emits: ['click'],

        props: {
            type: {
                type: String,
                default: 'submit'
            },
            disabled: Boolean,
            shrink: {
                type: Boolean,
                default: true
            },
            loading: Boolean,
            icon: String
        },

        data() {
            return {
                style: {
                    width: null,
                    height: null
                },
            }
        },

        mounted() {
            this.updateSize();
        },

        updated() {
            // this.updateSize();
        },

        watch: {
            loading() {
                if(this.loading && this.shrink) {
                    this.style.width = this.style.height;
                }

                else {
                    this.updateSize();
                }
            }
        },

        methods: {

            updateSize() {
                if (! this.shrink) {
                    return;
                }

                this.style = {
                    width: null,
                    height: null
                };

                setTimeout(() => {
                    this.style = {
                        width: this.$el.clientWidth + 1 + 'px',
                        height: this.$el.clientHeight + 1 + 'px'
                    }
                }, 405);
            },

            onClick() {
                if(this.disabled) {
                    return;
                }

                this.$emit('click');
            }

        },

        computed: {

        }

    }

</script>

<style lang="scss" scoped>

    .app-button {
        .icon {

            svg {
                display: block;
            }
        }


        .loader {

            ::v-deep svg {
                display: block;
                width: 100%;
                height: 100%;
            }
        }

    }

</style>
